import { SxProps, Theme } from '@mui/material';

export const LocateStorePanelTitleSX: Record<string, SxProps<Theme>> = {
	containerPadding: {
		p: '15px 20px',
	},
	cursorPointer: {
		cursor: 'pointer',
	},
	icon: {
		mr: '5px',
		color: 'primary.main',
	},
	title: {
		width: '100%',
	},
};
